import type { TReminderLog } from '@src/shared/types/reminder';

export function getRecipientDisplay(log: TReminderLog) {
  const { lead, recipient } = log;

  const recipientName =
    `${recipient?.first_name ?? ''} ${recipient?.last_name ?? ''}`.trim();
  const leadName = lead?.name?.trim();

  const name = leadName || recipientName || '—';
  const avatarUrl = recipient?.avatar || '';

  return { name, avatarUrl };
}
